import React from 'react'
import { Box, SimpleGrid, VStack, Spinner, Button} from '@chakra-ui/react'
import { LuExternalLink } from "react-icons/lu"

interface Classes {
  title: any
  subtitle: any
  wrapper?: any
}

interface InformativeLayerProps {
  title: React.ReactNode
  paragraph?: React.ReactNode
  image: React.ReactNode
  action?: () => any
  isLoading?: boolean
  classes?: Classes
  textButton?: string
  variantButton?: string
  support?: React.ReactNode
}

const InformativeLayer: React.FC<InformativeLayerProps> = ({
  title,
  paragraph,
  image,
  action,
  isLoading = false,
  textButton,
  variantButton,
  support,
}) => (
  <SimpleGrid data-testid='info-grid' columns={3} overflowY='auto' maxH='calc(100vh - 96px)'>
    <Box data-testid='left-offset'></Box>
    <VStack data-testid='centert-offset'  h={222} p={24} mt='257px' justifyContent='center'>
      <Box data-testid='image' h={96} textAlign='center'  justifyContent='center'>
        { isLoading && (<Spinner data-testid='spinner' variant="default" />)}
        { !isLoading && (image)}        
      </Box>  
      <Box data-testid='title' h={32} mt='0px' textAlign='center' minW={'1392px'} >
        {title}
      </Box>
      <Box data-testid='paragraph' h={38} p={[0, 0, 16, 0]} minW={'1392px'} >
        {paragraph}
      </Box>      
  {typeof action === 'function' && !isLoading && variantButton && textButton && (
      <Box data-testid='action' h={24}>
        <Button 
          data-testid='button'
          variant={variantButton}
          colorScheme='blue'
          size={'lg'}
          minW='204px'
          onClick={() => action()}
          leftIcon={textButton === 'Solicitar una mejora' ? <LuExternalLink style={{ margin: 0 }}/> : undefined}
          >
          {' '} {textButton} {' '}
         </Button>
      </Box>
    )}
      {support}
    </VStack>
    <Box data-testid='right-offset'></Box>
  </SimpleGrid>
)

export default InformativeLayer
